import { __decorate } from "tslib";
import { action } from 'mobx';
import { matchPath } from 'react-router';
import StoreBuilder from '../Stores/Core/StoreBuilder';
import StoreLoadingBar from '../Stores/Tools/StoreLoadingBar';
import history from "./History";
import { PublicRoutes } from './PublicRoutes';
var AppHistoryHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     */
    function AppHistoryHelpers() {
        /**Stores history */
        this.history = null;
        /**Store offline controller path */
        this.offlinePath = '/offline';
        /**Shoud be used only with the component replace on a push state */
        this.PreventComponentUpdate = false;
        /**Has internet connection */
        this.Online = true;
        /**Reference to the main scroll view component */
        this.ScrollView = null;
        return;
    }
    /**
     * Class initializer
     * @param {Array<string>} publicRoutes List of public routes paths
     */
    AppHistoryHelpers.prototype.Initialize = function (publicRoutes) {
        var that = this;
        var curLocation = '';
        that.history = history;
        that.NativeBasePath = window.location.href;
        that.Online = navigator.onLine;
        that.AddPublicRoutes(publicRoutes);
        that.history.listen(function (listner) {
            StoreLoadingBar.Show();
            StoreBuilder.HistoryChanged(listner.pathname, that.IsPublicRoute(listner.pathname));
        });
        window.addEventListener('offline', function () {
            that.Online = false;
        });
        window.addEventListener('online', function () {
            that.Online = true;
        });
        curLocation = that.history.location.pathname;
        StoreBuilder.IsSignIn = curLocation === '/' || curLocation === '' || curLocation.indexOf('sign') > -1;
        StoreBuilder.IsPublicRoute = that.IsPublicRoute();
    };
    /**
     * Fill list of public routes
     * @param {Array<string>} publicRoutes List of public routes
     */
    AppHistoryHelpers.prototype.AddPublicRoutes = function (publicRoutes) {
        var _this = this;
        this.PublicRoutes = publicRoutes === undefined ? [] : publicRoutes;
        this.PublicRoutes.push(PublicRoutes.Contacts);
        PublicRoutes.Register.forEach(function (route) {
            _this.PublicRoutes.push(route);
        });
    };
    /**
     * History push
     * @param {string} path New path
     * @param {any} state State (if any)
     * @param {boolean} preventComponentUpdate If true prevent component update
     * @param {any} e If triggered by link, has the event
     * @returns {boolean} Returns ALWAYS false in case it is called via a link
     */
    AppHistoryHelpers.prototype.Push = function (path, state, preventComponentUpdate, e) {
        if (state === void 0) { state = null; }
        if (preventComponentUpdate === void 0) { preventComponentUpdate = false; }
        if (e === void 0) { e = null; }
        var scrollTop = this.GetScrollTop();
        var hideLoading = false;
        if (e !== null) {
            e.preventDefault();
        }
        if (path === this.history.location.pathname) {
            hideLoading = true;
        }
        StoreLoadingBar.Show();
        this.ScrollTop();
        if (this.history.location.pathname !== this.offlinePath) {
            if (this.history.location.state === null || this.history.location.state === undefined) {
                this.Replace(this.history.location.pathname, {
                    scrollTop: scrollTop
                }, true, false);
            }
            else {
                var newState = this.history.location.state;
                newState.scrollTop = scrollTop;
                this.Replace(this.history.location.pathname, newState, true, false);
            }
        }
        if (this.Online) {
            this.PreventComponentUpdate = preventComponentUpdate;
            this.history.push(path, state);
            this.PreventComponentUpdate = false;
        }
        else {
            this.OfflinePush(path);
        }
        if (hideLoading) {
            StoreLoadingBar.Hide();
        }
        return false;
    };
    /**
     * Go to main offline page
     * @param {string} path Path to return to
     * @param {boolean} partiallyInitialized Application was already initialized
     * @returns { boolean } Returns ALWAYS false in case it is called via a link
     */
    AppHistoryHelpers.prototype.OfflinePush = function (path, _partiallyInitialized) {
        if (_partiallyInitialized === void 0) { _partiallyInitialized = false; }
        if (this.history.location.pathname !== this.offlinePath) {
            this.history.push(this.offlinePath, {
                origin: path,
                scrollTop: 0
            });
        }
        return false;
    };
    /**Redirect user to choosen request before going offline */
    AppHistoryHelpers.prototype.OnlineRestore = function () {
        if (this.history.location.state === undefined) {
            var path = window.location.href; //unecessary but lint complains: 'window.location.href' is assigned to itself  no-self-assign
            window.location.href = path;
        }
        else if (this.Online) {
            this.history.replace(this.history.location.state.origin);
        }
    };
    /**
     * History replace
     * @param {string} path New path
     * @param {any} state State (if any)
     * @param {boolean} preventComponentUpdate flag prevent component update)
     * @param {boolean} showLoading Show loading component
     */
    AppHistoryHelpers.prototype.Replace = function (path, state, preventComponentUpdate, showLoading) {
        if (state === void 0) { state = null; }
        if (preventComponentUpdate === void 0) { preventComponentUpdate = false; }
        if (showLoading === void 0) { showLoading = true; }
        StoreLoadingBar.Show();
        this.PreventComponentUpdate = preventComponentUpdate;
        this.history.replace(path, state);
        this.PreventComponentUpdate = false;
    };
    /**Restore scroll top position (if any) */
    AppHistoryHelpers.prototype.RestoreScrollTop = function () {
        var state = this.history.location.state;
        var scrollTop = 0;
        if (state !== null && state !== undefined) {
            scrollTop = state.scrollTop;
            if (scrollTop !== null && scrollTop !== undefined) {
                this.ScrollTop(scrollTop);
            }
        }
    };
    /**
     * Check if the current route is to be displayed with the public layout
     * @param {string} path Current path
     * @param {string | Array<string>} routePaths Optional routes to compare to
     * @returns {boolean} True if it is a public route, false otherwise
     */
    AppHistoryHelpers.prototype.IsPublicRoute = function (path, routePaths) {
        var _this = this;
        if (path === void 0) { path = ''; }
        if (routePaths === void 0) { routePaths = null; }
        var result = false;
        if (routePaths === null) {
            this.PublicRoutes.forEach(function (routePath) {
                if (matchPath(path === '' ? _this.history.location.pathname : path, {
                    path: routePath
                })) {
                    result = true;
                }
            });
        }
        else {
            this.PublicRoutes.forEach(function (route) {
                if (!result) {
                    if (typeof routePaths === 'string') {
                        result = route === routePaths;
                    }
                    else {
                        result = routePaths.filter(function (x) { return x === route; }).length > 0;
                    }
                }
            });
        }
        return result;
    };
    /**
     * Check if there is a valid reference to the scroll component
     * @returns {boolean} True if there is a reference, false otherwise
     * */
    AppHistoryHelpers.prototype.IsScrollAvailable = function () {
        return this.ScrollView !== null && this.ScrollView.current !== null;
    };
    /**
     * Get scroll top position
     * @returns {number} Scroll top value
     */
    AppHistoryHelpers.prototype.GetScrollTop = function () {
        return !this.IsScrollAvailable() ? 0 : this.ScrollView.current.instance.scrollOffset().top;
    };
    /**Scroll scroll view to top */
    AppHistoryHelpers.prototype.ScrollTop = function (topPosition) {
        if (topPosition === void 0) { topPosition = 0; }
        if (this.IsScrollAvailable()) {
            this.ScrollView.current.instance.scrollTo(topPosition);
        }
    };
    __decorate([
        action
    ], AppHistoryHelpers.prototype, "Push", null);
    return AppHistoryHelpers;
}());
var AppHistory = new AppHistoryHelpers();
export default AppHistory;
//# sourceMappingURL=AppHistory.js.map